import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function ScrollViewListTemplate({ item, type, playersFixture }) {
    const PLACEHOLDER_IMAGE =
        'https://smorasstats.com/v4/wp-content/uploads/2020/01/5d5fe9333b21a2019-08-23hnesse-1.jpg'
    const [image, setImage] = useState(PLACEHOLDER_IMAGE)

    useEffect(() => {
        if (type === 'player') {
            setImage(item?.player_image || PLACEHOLDER_IMAGE)
        }
    }, [type, item])

    return (
        <div className="scrollItem px-2">
            <Link to={`/live-fixtures/single/${item?.fixture_id}`}>
                <img
                    src={playersFixture[0]?.player_image || PLACEHOLDER_IMAGE}
                    alt=""
                    className="img-fluid"
                />
                <p>
                    <small>{playersFixture[0]?.player_name}</small>
                    <br />
                    <span className="text-muted">
                        <small>{playersFixture[0]?.api_data?.team_name}</small>
                    </span>
                </p>
            </Link>
        </div>
    )
}
export default ScrollViewListTemplate
